import { AssessmentStepKeys } from '@/enums'
import { makeBusinessTypeSubmitValue } from '../../helpers'
import { ConditionalOfferAssessment } from './BasePage'

interface Messages {
  helperText: string
}

type StepProps = Partial<
  Record<
    AssessmentStepKeys,
    {
      categoryId?: string
      helperText?: string
    }
  >
>

interface SubmitValues {
  approxRevenue: any
  businessType: any
  companyFoundedDateLead: any
  [key: string]: any
}

const legalAssessmentSteps = [
  AssessmentStepKeys.businessTypeAi,
  AssessmentStepKeys.businessTypeConfirmationAi,
  AssessmentStepKeys.businessTypeMainSelectionAi,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.employeesCount,
  AssessmentStepKeys.approxRevenue,
  AssessmentStepKeys.startDate,
]

const categoryId = 'LE'

const makeSubmitValues = () => {
  return function transform<T>(values: T): T {
    const typedValues = (values as unknown) as SubmitValues
    const {
      approxRevenue,
      businessType,
      companyFoundedDateLead,
      ...steps
    } = typedValues
    return ({
      ...steps,
      lastYearFinances: approxRevenue,
      businessType: makeBusinessTypeSubmitValue(businessType),
      companyFoundedDate: companyFoundedDateLead,
    } as unknown) as T
  }
}

const makeStepProps = (messages: Messages): StepProps => ({
  [AssessmentStepKeys.businessTypeConfirmationAi]: {
    categoryId,
  },
  [AssessmentStepKeys.approxRevenue]: {
    helperText: messages.helperText,
  },
})

export const LegalConditionalOffer = () => (
  <ConditionalOfferAssessment
    categoryId={categoryId}
    makeStepProps={makeStepProps}
    stepKeys={legalAssessmentSteps}
    transformSubmitValues={makeSubmitValues()}
  />
)
